var members_zone = ( function ( $ ) {

	var $button;

	var _init = function () {
		$button = $( 'a#usabcd-redirect' );

		$button.on( 'click', _usabcd_ajax );
	};

	var _usabcd_ajax = function ( e ) {
		e.preventDefault();

		var data = {
			action: 'usabcd_redirect',
			nonce: ScriptData.usabcd_redirect_nonce
		};

		$.post( ScriptData.ajaxurl, data, _usabcd_ajax_response );
	};

	var _usabcd_ajax_response = function ( response ) {
		if ( response.redirect ) {
			window.location.href = response.redirect;
		}
	};

	if ( $( '.page-template-members-zone-inner' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = members_zone;